export const WORK_SHIFT = 'WorkShift';
//# sourceMappingURL=work-shift.js.map